module.exports = {
  "country": "AT",
  "artist": "Conchita Wurst",
  "song": "Rise like a Phoenix",
  "year": "2014",
  "place": "1",
  "spotify": "0fvafkeEoF6Y9gGLK3Wnu3"
};